<p-select
  [options]="serviceCodeList"
  [multiple]="true"
  [disabled]="disabled()"
  [ngModel]="selectedServiceCodes"
  (ngModelChange)="selectedServiceCodes = $event; onSelectionChange()"
  [appendTo]="appendTo()"
  panelStyleClass="p-select-checkbox-options"
  placeholder="Select"
  [class]="required() && !selectedServiceCodes?.length ? 'has-error' : ''"
>
  <ng-template #item let-option>
    <p-checkbox
      [ngModel]="isSelected(option.value)"
      [binary]="true"
      [readonly]="true"
      [tabindex]="-1"
    />
    <span>{{ option.label }}</span>
  </ng-template>

  <ng-template #selectedItem>
    <app-selected-chips
      [items]="selectedServiceCodes"
      [label]="chipLabel"
      [removable]="!disabled()"
      (removeItem)="removeServiceCode($event)"
    />
  </ng-template>
</p-select>
